import SwipeToConfirmButton from "./SwipeToConfirmButton"

export default SwipeToConfirmButton
